import {httpRequest} from "./http-request";
import {notification} from "antd";
import i18n from "../i18n";
import moment from "moment";


export const legalEntityService = {
    getNewLegalEntityInfo,
    getLegalEntityDocsArchive,
    validateKazakhstanLegalEntityByStep,
    createKazakhstanLegalEntity,
    editKazakhstanLegalEntity,
    editRusLegalEntityData,
    editKazLegalEntityData,
    editBelLegalEntityData,
    getTaxTypes,
    changeLegalEntityTaxType,
    changeLegalEntityGosLog,
    changeConsignorGosLog,
    addConsignorGosLogWithApproveDocs,
    getGosLogInfo,
    changeNumberExtract,
    checkGosLog,
    checkLegalEntityDocs,
    saveAdditionalRusLegalEntityDocs
}

/**
 * Редактирование данных российского юр. лица
 * LegalEntityId
 * Name
 * FullName
 * FirstName
 * SecondName
 * Patronymic
 * Bic
 * Rs
 * RegAddress
 * LegalAddress
 * MailingAddress
 * @returns {Promise<any>}
 * @param legalEntityId
 * @param legalEntityData
 */
async function editRusLegalEntityData(legalEntityId, legalEntityData) {
    const formData = new FormData();

    for (const key in legalEntityData) {
        let keyName = key;
        keyName = keyName.charAt(0).toUpperCase() + keyName.slice(1);

        formData.append(keyName, legalEntityData[key]);
    }
    formData.append('LegalEntityId', legalEntityId);
    return await httpRequest
      .post(`legal-entity/edit-rus-legal-entity-via-approve`, formData)
      .then((response) => {
        if (response.status === 200 || response.status === 202) {
            return Promise.resolve(response.data);
        }

        return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

/**
 * Редактирование данных казахстанского юр. лица
 * LegalEntityId
 * Name
 * FullName
 * FirstName
 * SecondName
 * Patronymic
 * BankName
 * Bic
 * Rs
 * RegRegion
 * RegLocality
 * RegStreet
 * RegHouseNumber
 * RegPremiseNumber
 * RegPostalCode
 * LegalRegion
 * LegalStreet
 * LegalLocality
 * LegalHouseNumber
 * LegalPremiseNumber
 * LegalPostalCode
 * @returns {Promise<any>}
 * @param legalEntityId
 * @param legalEntityData
 */
async function editKazLegalEntityData(legalEntityId,legalEntityData) {
    const formData = new FormData();

    for (const key in legalEntityData) {
        let keyName = key;
        keyName = keyName.charAt(0).toUpperCase() + keyName.slice(1);

        formData.append(keyName, legalEntityData[key]);
    }
    formData.append('LegalEntityId', legalEntityId);

    return await httpRequest
      .post(`legal-entity/edit-kaz-legal-entity-via-approve`, formData)
      .then((response) => {
          if (response.status === 200 || response.status === 202) {
              return Promise.resolve(response.data);
          }

          return Promise.reject(httpRequest.getDefaultMessageError());
      });
}

/**
 * Редактирование данных беларусского юр. лица
 * LegalEntityId
 * Name
 * FullName
 * FirstName
 * SecondName
 * Patronymic
 * BankName
 * Bic
 * AccountNumber
 * AddressCity
 * Address
 * MailingAddress
 * @returns {Promise<any>}
 * @param legalEntityId
 * @param legalEntityData
 */
async function editBelLegalEntityData(legalEntityId,legalEntityData) {
    const formData = new FormData();

    for (const key in legalEntityData) {
        let keyName = key;
        keyName = keyName.charAt(0).toUpperCase() + keyName.slice(1);

        formData.append(keyName, legalEntityData[key]);
    }
    formData.append('LegalEntityId', legalEntityId);

    return await httpRequest
      .post(`company/edit-belarus-legal-entity-via-approve`, formData)
      .then((response) => {
          if (response.status === 200 || response.status === 202) {
              return Promise.resolve(response.data);
          }

          return Promise.reject(httpRequest.getDefaultMessageError());
      });
}

async function getNewLegalEntityInfo({inn}) {
    return await httpRequest.get(`legal-entity/get-new-legal-entity-info?inn=${inn}`).then((response) => {
        if (response.status === 200) {
            return Promise.resolve(response.data);
        }

        return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function changeLegalEntityTaxType(legalEntityId, workWithNds, taxType, taxPercent, docFields) {

    const formData = new FormData();

    formData.append('legalEntityId', legalEntityId);
    formData.append('workWithNds', workWithNds);
    formData.append('taxType', taxType);
    formData.append('taxPercent', taxPercent);

    for (const [key, value] of Object.entries(docFields)) {
        if (Array.isArray(value)) {
            let count = 1;
            for (const file of value) {
            if (count > 1) {
                formData.append(key + count, file);
            } else {
                formData.append(key, file);
            }
            count++;
            }
        } else {
            formData.append(key, value[0]);
        }
    }

    return await httpRequest
        .post('legal-entity/change-tax-type', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
        .then((response) => {
            if (response.status === 200 || response.status === 202) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

async function getTaxTypes() {
    return await httpRequest.get('system/get-tax-types')
        .then((response) => {

            if (response.status === 200 && typeof response.data !== "undefined") {
                return Promise.resolve(response.data);
            }

            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

async function changeLegalEntityGosLog(legalEntityId, gosLogValue, docFields, comment = '', consignorId = null) {
    const formData = new FormData();
    formData.append('legalEntityId', legalEntityId);
    formData.append('gosLog', gosLogValue);
    formData.append('comment', comment);
    formData.append('consignorId', consignorId);

    if (docFields && Object.keys(docFields).length > 0) {
        for (const [key, value] of Object.entries(docFields)) {
            if (Array.isArray(value)) {
                let count = 1;
                for (const file of value) {
                    if (count > 1) {
                        formData.append(key + count, file);
                    } else {
                        formData.append(key, file);
                    }
                    count++;
                }
            } else {
                formData.append(key, value[0]);
            }
        }
    }

    return await httpRequest
        .post('legal-entity/change-gos-log', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
        .then((response) => {
            if (response.status === 200 || response.status === 202) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

async function changeConsignorGosLog(consignorId, legalEntityId, docFields, comment = '', numberExtract = null, status = '1') {
    const formData = new FormData();
    formData.append('consignorId', consignorId);
    formData.append('legalEntityId', legalEntityId);
    formData.append('gosLog', status);
    formData.append('comment', comment);
    formData.append('number_extract', numberExtract ? String(numberExtract) : '');

    if (docFields && Object.keys(docFields).length > 0) {
        for (const [key, value] of Object.entries(docFields)) {
            if (Array.isArray(value)) {
                let count = 1;
                for (const file of value) {
                    if (count > 1) {
                        formData.append(key + count, file);
                    } else {
                        formData.append(key, file);
                    }
                    count++;
                }
            } else {
                formData.append(key, value[0]);
            }
        }
    }

    return await httpRequest
        .post('legal-entity/change-gos-log', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
        .then((response) => {
            if (response.status === 200 || response.status === 202) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

async function checkGosLog(legalEntityId, consignorId) {
    return await httpRequest
        .get('legal-entity/check-goslog', {
            params: {
                legalEntityId: legalEntityId,
                consignorId: consignorId
            }
        })
        .then((response) => {
            if (response.status === 200 || response.status === 202) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

async function addConsignorGosLogWithApproveDocs(consignorId, legalEntityId) {
    const formData = new FormData();
    formData.append('consignorId', consignorId);
    formData.append('legalEntityId', legalEntityId);

    return await httpRequest
        .post('legal-entity/add-consignor-gos-log-with-approve-docs', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
        .then((response) => {
            if (response.status === 200 || response.status === 202) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

async function getGosLogInfo(legalEntityId, consignorId) {
    return await httpRequest
        .get('legal-entity/get-gos-log-info', {
            params: {
                legalEntityId: legalEntityId,
                consignorId: consignorId
            }
        })
        .then((response) => {
            if (response.status === 200 || response.status === 202) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

async function changeNumberExtract(consignorId, legalEntityId, numberExtract) {
    const formData = new FormData();
    formData.append('consignorId', consignorId);
    formData.append('legalEntityId', legalEntityId);
    formData.append('number_extract', numberExtract === null ? '' : String(numberExtract));

    return await httpRequest
        .post('legal-entity/change-number-extract', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
        .then((response) => {
            if (response.status === 200 || response.status === 202) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

async function getLegalEntityDocsArchive({id}) {
    return await httpRequest.get(`legal-entity/download-files-archive?id=${id}`).then((response) => {
        if (response.status === 200) {
            return Promise.resolve(response.data);
        }

        return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function validateKazakhstanLegalEntityByStep(data, step, orgFormID, legalEntityID = null) {
    const formData = createKazakhstanLegalEntityFormData(data, orgFormID);
    if (legalEntityID) {
        formData.append('legalEntityID', legalEntityID);
    }
    return await httpRequest
        .post(`legal-entity/validate-kazakhstan-legal-entity-by-step?stepNumber=${step}`, formData, {})
        .then((response) => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }

            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

async function createKazakhstanLegalEntity(data, orgFormID, files, isAgree = 0) {
    const formData = createKazakhstanLegalEntityFormData(data, orgFormID, isAgree);

    for (const [key, value] of Object.entries(files)) {
        if (Array.isArray(value)) {
            let count = 0;
            for (const file of value) {
                let fileName = (count > 0) ? key + count : key;

                formData.append(fileName, file);
                count++;
            }
        } else {
            formData.append(key, value);
        }
    }

    return await httpRequest
        .post("legal-entity/create-kazakhstan-legal-entity", formData, {})
        .then((response) => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }

            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

async function editKazakhstanLegalEntity(legalEntityID, data, orgFormID) {
    const formData = createKazakhstanLegalEntityFormData(data, orgFormID);
    formData.append('legalEntityID', legalEntityID);

    return await httpRequest
        .post("legal-entity/edit-kazakhstan-legal-entity", formData, {})
        .then((response) => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }

            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

function createKazakhstanLegalEntityFormData(data, orgFormID, isAgree = 0) {
    const formData = new FormData();

    formData.append('orgFormID', orgFormID);
    formData.append('workWithNds', data.workWithNds);
    formData.append('dateRegistration', (data.dateRegistration && moment.isMoment(data.dateRegistration)) ? data.dateRegistration.format('YYYY-MM-DD') : data.dateRegistration);
    formData.append('name', data.name);
    formData.append('iin', data.iin ? data.iin : '');
    formData.append('bin', data.bin ? data.bin : '');
    formData.append('atiCode', data.atiCode);
    formData.append('phone', data.phone);
    formData.append('email', data.email);
    formData.append('legalReason', data.legalReason);
    formData.append('firstName', data.firstName);
    formData.append('secondName', data.secondName);
    formData.append('patronymic', data.patronymic);
    formData.append('position', data.position);
    formData.append('rs', data.rs);
    formData.append('bic', data.bic);
    formData.append('bankName', data.bankName);
    formData.append('iik', data.iik);
    formData.append('bankLegalAddress', data.bankLegalAddress);
    formData.append('correspondentBankName', data.correspondentBankName);
    formData.append('correspondentBankInn', data.correspondentBankInn);
    formData.append('correspondentBankBic', data.correspondentBankBic);
    formData.append('correspondentBankLegalAddress', data.correspondentBankLegalAddress);
    formData.append('correspondentBankAccount', data.correspondentBankAccount);
    formData.append('correspondentBankCheckingAccount', data.correspondentBankCheckingAccount);
    formData.append('registrationNumber', data.registrationNumber);
    formData.append('certificateSerial', data.certificateSerial);
    formData.append('certificateNumber', data.certificateNumber);

    formData.append('legalRegion', data.legalRegion);
    formData.append('legalLocality', data.legalLocality);
    formData.append('legalStreet', data.legalStreet);
    formData.append('legalHouseNumber', data.legalHouseNumber);
    formData.append('legalPremiseNumber', data.legalPremiseNumber);
    formData.append('legalPostalCode', data.legalPostalCode);
    formData.append('regRegion', data.isRegEqualsLegal ? data.legalRegion : data.regRegion);
    formData.append('regLocality', data.isRegEqualsLegal ? data.legalLocality : data.regLocality);
    formData.append('regStreet', data.isRegEqualsLegal ? data.legalStreet : data.regStreet);
    formData.append('regHouseNumber', data.isRegEqualsLegal ? data.legalHouseNumber : data.regHouseNumber);
    formData.append('regPremiseNumber', data.isRegEqualsLegal ? data.legalPremiseNumber : data.regPremiseNumber);
    formData.append('regPostalCode', data.isRegEqualsLegal ? data.legalPostalCode : data.regPostalCode);

    formData.append('addGuarantor', data.addGuarantor ? data.addGuarantor : false);
    formData.append('guarantorFirstName', data.guarantorFirstName);
    formData.append('guarantorSecondName', data.guarantorSecondName);
    formData.append('guarantorPatronymic', data.guarantorPatronymic);
    formData.append('guarantorPassportSerial', data.guarantorPassportSerial);
    formData.append('guarantorPassportNumber', data.guarantorPassportNumber);
    formData.append('guarantorPassportDate', data.guarantorPassportDate);
    formData.append('guarantorCountry', data.guarantorCountry);
    formData.append('guarantorEmail', data.guarantorEmail);
    formData.append('guarantorPhone', data.guarantorPhone);

    return formData;
}

/**
 * Проверка документов юридического лица
 * Возвращает список недостающих документов
 * @param {number} legalEntityId - ID юридического лица
 * @param {number} consignorId - ID грузоотправителя
 * @returns {Promise<Array>} - список недостающих документов
 */
async function checkLegalEntityDocs(legalEntityId, consignorId) {
    return await httpRequest.get(`legal-entity/check-legal-entity-docs?LegalEntityId=${legalEntityId}&ConsignorId=${consignorId}`)
        .then((response) => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}

/**
 * Сохранение дополнительных документов российского юридического лица
 * @param {number} legalEntityId - ID юридического лица
 * @param {object} docs - объект с документами
 * @param {number} consignorId - ID Consignor
 * @returns {Promise<any>}
 */
async function saveAdditionalRusLegalEntityDocs(legalEntityId, docs, consignorId) {
    const formData = new FormData();
    formData.append('LegalEntityId', legalEntityId);
    formData.append('ConsignorId', JSON.stringify(consignorId));

    for (const [key, value] of Object.entries(docs)) {
        if (Array.isArray(value)) {
            for (const file of value) {
                formData.append(key, file);
            }
        } else if (value) {
            formData.append(key, value);
        }
    }

    return await httpRequest
        .post('legal-entity/save-additional-rus-legal-entity-docs', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
        .then((response) => {
            if (response.status === 200 || response.status === 202) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(httpRequest.getDefaultMessageError());
        });
}
